
import Vue from 'vue'

const getDefaultState = () => {
    return {
        actions: {
            id: 0,
            description: "",
            symbol: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("actions/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listActions = result.data.result;

                return listActions;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list construction actions: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`actions/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get actions`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get actions: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, actionsRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`actions/create-update`, actionsRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (actionsRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`actions/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },

    async ListTypeAnswer() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`actions/list-type-answer`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listTypeAnswer = result.data.result;

                return listTypeAnswer;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list type answer: [${ex}]`
            };
        }
    },    

    async CreateUpdateRegisters(_, actionsRegistersRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`actions/create-update-registers`, actionsRegistersRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (actionsRegistersRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    idActionRegister: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async GetRegisters(_, { idServiceProject, idAction }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`actions/get-registers/${idServiceProject}/${idAction}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get registers`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get registers: [${ex}]`
            };
        }
    },

    async ExportPDF(_, { idServiceProject, idAction }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`actions/export-pdf/${idServiceProject}/${idAction}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get registers`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get registers: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.actions, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.actions;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}